require('./baseState.js');

Pegasus.IdlingState = Pegasus.BaseState.extend({
  setup: function(){
    Pegasus.lookupController('historyOperations').set('shouldShow', true);
  },
  hover: function(manager, context){
    manager.transitionTo('hovering', context);
  },
  edit: function(manager, context){
    manager.transitionTo('editing', context);
  },
  gotoValidating: function(manager){
    manager.transitionTo('validating.confirming');
  },
  gotoTesting: function(manager){
    manager.transitionTo('validating.testing');
  },
  changePalette: function(manager, view){
    manager.transitionTo('editing.palette', view);
  }
});
